import { render, staticRenderFns } from "./EDadosGeraisTab.vue?vue&type=template&id=23bc8637"
import script from "./EDadosGeraisTab.vue?vue&type=script&lang=js"
export * from "./EDadosGeraisTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports